<template lang="html">
  <div class="__loading">
    <v-overlay :value="overlay" color="white">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      />
    </v-overlay>
  </div>
</template>

<script>
import {
  getDataDetail as getDataDetailOrder
} from '@/api/order'
export default {
  data() {
    return {
      order: {},
      new_order: {},
      overlay: true
    }
  },
  created() {
    this.checkStatus()
  },
  methods: {
    async checkStatus() {
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))) {
        this.order = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order'))
      } else {
        const astra_outlet = this.$store.state.store_astra
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain

        if (tmii_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://order.kulinertmii.id'
        } else if (astra_outlet.indexOf(url_id) !== -1) {
          window.location.href = 'https://zestloungemenaraastra.myolsera.com'
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      }

      try {
        let params = {}
        if (this.$store.state.selected_store.setting.no_auth_dinein) {
          params = {
            remark: 'OL-DINE-IN'
          }
        }
        const { data } = await getDataDetailOrder(this.order.id, params)
        this.$store.state.loading_axios = false
        this.new_order = data.data
        this.$store.dispatch('create_order', data.data)
        if (this.new_order.payment_log) {
          if (this.new_order.payment_log.global_status === 'P') {
            this.$router.push({ name: 'order_payment_pending' }).catch(() => {})
          } else if (this.new_order.payment_log.global_status === 'X') {
            this.$router.push({ name: 'order_payment_failed' }).catch(() => {})
          } else if (this.new_order.payment_log.global_status === 'Z') {
            this.$router.push({ name: 'order_success' }).catch(() => {})
          }
        } else {
          if (this.new_order.status === 'Z') {
            this.$router.push({ name: 'order_success' }).catch(() => {})
          } else if (this.new_order.status === 'X') {
            this.$router.push({ name: 'order_failed' }).catch(() => {})
          }
        }
      } catch (e) {
        return false
      }
    }
  }
}
</script>
